export enum ShiftMode {
  Presential = "PRESENTIAL",
  Online = "ONLINE"
}

export const SHIFT_MODE_OPTIONS = [
  { value: ShiftMode.Presential, label: "Presencial" },
  { value: ShiftMode.Online, label: "Online" }
];

export function normalizeShiftMode(value: string | null | undefined): ShiftMode {
  if (!value) {
    return ShiftMode.Presential;
  }

  const normalized = value.trim().toLowerCase();
  if (normalized === "online") {
    return ShiftMode.Online;
  }

  if (normalized === "presential" || normalized === "presencial" || normalized === "local") {
    return ShiftMode.Presential;
  }

  return ShiftMode.Presential;
}

export function getShiftModeLabel(value: string | null | undefined): string {
  const normalizedMode = normalizeShiftMode(value);
  const option = SHIFT_MODE_OPTIONS.find((mode) => mode.value === normalizedMode);
  return option?.label ?? normalizedMode;
}

export function shiftModeToTipoParam(mode: ShiftMode): string {
  return mode === ShiftMode.Presential ? "presencial" : "online";
}